<template>
  <router-link @click="trackClick" to="/ingredient-checker" class="ingredient-checker-promo">
    <img src="/images/promo-ingredient-checker.png" alt="Ingredient Checker promo">
  </router-link>
</template>

<script>
import { trackPromoClick } from '@/utils/activity';

export default {
  name: 'IngredientCheckerPromo',
  props: {
    source: {
      type: String,
      default: null,
      validator: value => ['test-kits', 'test-results'].includes(value),
    },
  },
  methods: {
    trackClick() {
      trackPromoClick('ingredient-checker', this.source);
    },
  },
};
</script>

<style scoped>
.ingredient-checker-promo {
  display: block;
  width: 90%;
  margin-left: auto;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 10px 24px rgba(15, 38, 95, 0.08);
}

.ingredient-checker-promo img {
  display: block;
  width: 100%;
  height: auto;
}

@media (max-width: 639px) {
  .ingredient-checker-promo {
    width: 100%;
    margin-left: 0;
    border-radius: 16px;
  }
}
</style>